<template>
  <div v-if="warnings.length > 0" class="warnings-container">
    <div class="container all_docs">
      <div v-for="(item, index) in warnings" :key="index">
        <a @click="remove(index)">X</a>
        {{ displayWarning(item) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Warnings',
  data () {
    return {
      warnings: []
    }
  },
  methods: {
    warning (warning) {
      this.warnings.push(warning)
    },
    remove (index) {
      this.warnings = this.warnings.slice(0, index).concat(this.warnings.slice(index + 1))
    },
    displayWarning (war) {
      if (typeof war === 'object' && typeof war.message !== 'undefined') {
        return war.message
      }
      return war
    }
  }
}
</script>
<style lang="scss" scoped>
.warnings-container {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: white;
  max-height: 40vh;
  overflow-y: auto;
  z-index: 5;
  .all_docs {
    padding: 25px 0px;
  }
}
</style>
